function Swap(props){
    return (
        <img className="ml-3" src="https://cdn-icons-png.flaticon.com/512/61/61165.png" alt="Swap"/>
    )
}

export default Swap